import { Alert, AlertIcon, Button, HStack, Text, useToast } from "@chakra-ui/react";
import { useAuth } from "../../features/auth/hooks/useAuth";
import { useResendVerificationMutation } from "../../features/auth/hooks/useResendVerificationMutation";

// Corrige o bug do DashboardLayout.js original, que checava `user.status === false`
// (campo errado E tipo errado). A fonte correta é `is_email_verified` vindo de
// GET /api/v1/me (exposto pelo AuthProvider).
export default function EmailNaoVerificadoBanner() {
  const { user, isEmailVerified } = useAuth();
  const toast = useToast();
  const resendMutation = useResendVerificationMutation();

  if (!user || isEmailVerified) {
    return null;
  }

  const reenviar = () => {
    resendMutation.mutate(user.email, {
      onSuccess: () =>
        toast({ title: "Link de verificação reenviado", status: "success", duration: 4000 }),
    });
  };

  return (
    <Alert status="warning" justifyContent="center">
      <HStack spacing={3}>
        <AlertIcon />
        <Text fontSize="sm">Seu e-mail ainda não foi verificado.</Text>
        <Button size="sm" variant="outline" onClick={reenviar} isLoading={resendMutation.isPending}>
          Reenviar link
        </Button>
      </HStack>
    </Alert>
  );
}
